import React from 'react';
import Load from 'components/Load';
import basePath from 'utils/basePath';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import { Route } from 'react-router-dom';
import { openExternalLinkSimple } from 'utils/openExternalLink';

const AsyncInfoPage = Load(() => import(/* webpackChunkName: "info-pages" */'./components/InfoPage'), {}, true);

const COVID_LINK = "https://support.withlocals.com/hc/en-us/articles/360011989480-Coronavirus-information-and-extenuating-circumstances-policy-for-guests";

const InfoPagesRoutes = [
  (
    <Route
      key="travel-safely-redirect"
      path={`${basePath}/travel-safely/`}
      component={() => {
        openExternalLinkSimple(COVID_LINK);
        return null;
      }}
    />
  ),
  (
    <NavigationableLayout
      key="prismic"
      path={`${basePath}/info/:uid/`}
      component={AsyncInfoPage}
    />
  ),
];

export default InfoPagesRoutes;
